<template>
  <el-dialog
    :close-on-click-modal="false"
    title="批量设置工资"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="800px"
  >
    <section v-loading="getDetailLoading" class="salaryDialog">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
        <section slot="salaryOther" slot-scope="prop">
          <SetSalary ref="setSalary" :salaryPattern="prop.form.salaryPattern" />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
import {
  getEnumList,
} from 'api';
import {
  driverArchivesSetSalary,
} from 'api/archives';
import SetSalary from './setSalary';
export default {
  components: {
    SetSalary,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: [],
      formData: {
        salaryPatternOptions: [],
        form: [
          {
            label: '薪资模式',
            value: 'salaryPattern',
            type: 'select',
          },
          {
            value: 'salaryOther',
            allCustom: true,
          },
        ],
        rules: { // 表单验证规则
          salaryPattern: [ // 薪资模式
            { required: true, message: '请选择薪资模式', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      if (item) { // 修改
        this.type = 'edit';
        this.originData = item;
        this.$nextTick(() => {
          if (this.formData.salaryPatternOptions.length !== 0) {
            this.$refs.customForm.setVal('salaryPattern', this.formData.salaryPatternOptions[0].value);
          }
        });
      } else { // 新增
        this.type = 'add';
      }
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const userIds = this.originData.map((item) => item.userId);
      let userSalaryInfoList = this.$refs.setSalary.sub();
      if (userSalaryInfoList) {
        userSalaryInfoList = JSON.stringify(userSalaryInfoList);
      }
      const res = await driverArchivesSetSalary({
        salaryPattern: form.salaryPattern,
        userSalaryInfoList,
        userIds: userIds.join(','),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SALARY_PATTERN_STS',
    });
    // enumsList[0].shift();
    enumsList[0].splice(enumsList[0].findIndex((item) => item.label === '收入比例模式'), 1);
    this.formData.salaryPatternOptions = enumsList[0];
    if (this.$refs.customForm && this.dialogFormVisible) {
      this.$refs.customForm.setVal('salaryPattern', this.formData.salaryPatternOptions[0].value);
    }
  },
};
</script>

<style scoped lang="scss">
.salaryDialog {
  ::v-deep .customForm {
    width: 750px;
  }
}
</style>
